import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum DashboardSecurityRight {
    // CanViewSystemDashboards = 24000,
    CanCreateDashboards = 24001,
    CanManageOtherUsersDashboards = 24002,
}

export class DashboardSecurityModule extends BaseSecurityModule<DashboardSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Dashboards,
            [
                // { _id: DashboardSecurityRight.CanViewSystemDashboards, name: 'View System Dashboards', basic: true },
                { _id: DashboardSecurityRight.CanCreateDashboards, name: 'Create Dashboards', basic: true },
                { _id: DashboardSecurityRight.CanManageOtherUsersDashboards, name: 'Manage Other Users Dashboards', basic: true },
            ] as SecurityRight<DashboardSecurityRight>[]
        );
    }


}
